export const CHAMADA_PAINEL_ROUTES = {
  ROOT: '/painel',
} as const

export const CHAMADA_PAINEL_API_ROUTES = {
  LOGIN: '/api/painel-chamadas/dispositivo/login',
  STATUS: '/api/painel-chamadas/dispositivo/status',
  GERAR_PIN: '/api/painel-chamadas/dispositivo/pareamento/pin',
  STATUS_PAREAMENTO: (uuid: string) => `/api/painel-chamadas/dispositivo/pareamento/status/${uuid}`,
  CHAMADAS: '/api/painel-chamadas/chamadas',
} as const

export const CHAMADA_PAINEL_STORAGE_KEYS = {
  CREDENCIAIS: 'PEC_CHAMADA_PAINEL_CREDENCIAIS',
  DADOS_PAREAMENTO: 'PEC_CHAMADA_PAINEL_DADOS_PAREAMENTO',
} as const

export const CHAMADA_PAINEL_TIMERS = {
  KEEP_ALIVE_INTERVAL: 180000, // 3 minutos
  POLLING_PAREAMENTO: 5000, // 5 segundos
  DESTAQUE_CHAMADA: 5000, // 5 segundos
  HISTORICO_CHAMADAS_MINUTOS: 30,
  MAX_CHAMADAS_PROCESSADAS: 4, // chamada atual + 3 cards de histórico
  MAX_TENTATIVAS_ATMOSPHERE: 3,
  DELAY_RETRY_ATMOSPHERE: 3000, // 3 segundos
} as const
